import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'city-tax-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {
  supportLanguages = ["en", "es"];
  selected = "en";

  @Input() theme: string = 'light'; // Default theme, can be 'dark' or other values.

  constructor(
    private translate: TranslateService,
  ) {
  }

  ngOnInit(): void {
    const browserLanguage = this.translate.getBrowserLang();
    this.selected = this.translate.getDefaultLang();
    this.translate.use(browserLanguage || this.selected);
  }

  setLang(event: any) {
    this.selected = event;
    this.translate.use(event);
    this.translate.setDefaultLang(event);
  }

}
